import {RootState} from '../../utils/types';

export const projectsSelector = (state: RootState) =>
state.projectsList.projects